module.exports = __webpack_public_path__ + "img/info-circle.bdf30aa3.svg";